import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useSocket } from '../../hooks/useSocket.ts';
import { useUploads } from '../../store/uploads.ts';
import { TopBar } from './TopBar.tsx';
import { Sidebar } from './Sidebar.tsx';
import { UploadPanel } from '../upload/UploadPanel.tsx';

export function AppShell() {
  const socketState = useSocket();
  const queryClient = useQueryClient();
  const setOnFinished = useUploads((s) => s.setOnFinished);
  const items = useUploads((s) => s.items);

  useEffect(() => {
    setOnFinished((namespaceId) => {
      void queryClient.invalidateQueries({ queryKey: ['nodes', namespaceId] });
      void queryClient.invalidateQueries({ queryKey: ['me'] });
    });
  }, [setOnFinished, queryClient]);

  // 업로드가 진행 중일 때 탭을 닫으면 진행분이 사라진다는 것을 알린다
  useEffect(() => {
    const active = items.some(
      (i) => i.state === 'hashing' || i.state === 'uploading' || i.state === 'queued',
    );
    if (!active) return;
    const handler = (e: BeforeUnloadEvent): void => { e.preventDefault(); };
    window.addEventListener('beforeunload', handler);
    return () => { window.removeEventListener('beforeunload', handler); };
  }, [items]);

  return (
    <div className="shell">
      <TopBar socketState={socketState} />
      <div className="body">
        <Sidebar />
        <main className="main">
          {socketState === 'offline' && (
            <div className="banner">연결이 끊겼습니다. 다시 연결하는 중…</div>
          )}
          <Outlet />
        </main>
      </div>
      <UploadPanel />
    </div>
  );
}
